/**
 * L'appel d'offres que NOMME le lien d'une tâche — la seule lecture de « ce lien est un AO ».
 *
 * Lue par la modale « Nouvelle tâche » (`useDestinatairesDeLaTache` : seuls les collègues qui
 * voient l'AO lui sont proposés) et par le rail des échéances (`TenderDeadlinesPanel` : seule une
 * tâche ENCORE liée à cet AO se rattache à son échéance — décision PO n° 66). Module sans
 * dépendance : le rail ne tire ni crochet ni requête pour une comparaison.
 */

import type { LinkedEntityValue } from '@/lib/linkedEntity'

/** L'identifiant de l'AO que nomme `lien`, ou `null` (aucun lien, ou une autre fiche). */
export function aoDuLien(lien: LinkedEntityValue | null | undefined): string | null {
    return lien?.type === 'tender' && lien.id ? lien.id : null
}
